<template>
  <div class="initial-settings">
    <div class="label mt-2 mb-1">Notification Settings</div>
    <p>Here you can specify for which events you want to receive a notification to your configured E-Mail address.</p>

    <div class="row">
      <div class="col-6">
        <div class="label mt-2 mb-1">E-Mail Address</div>
        <input class="form-control form-control-sm" v-model="user.email" type="text" @input="() => (isDirty = true)" />
      </div>
    </div>
    <div>
      <div class="label mt-4 mb-1">Available notifications</div>
      <div class="pl-2">
        <checkbox-with-label
          :label="'Task was assigned to you'"
          v-model="user.notificationAssigned"
          @input="() => (isDirty = true)"
        ></checkbox-with-label>

        <checkbox-with-label
          class="mt-1"
          :label="'Subscribed task has been changed'"
          v-model="user.notificationSubscription"
          @input="() => (isDirty = true)"
          v-b-tooltip.left
          title="You can subscribe to changes in the collaboration section of each task"
        ></checkbox-with-label>

        <checkbox-with-label
          class="mt-1"
          :label="'A new task on one of your boards has been created'"
          v-model="user.notificationNewTask"
          @input="() => (isDirty = true)"
        ></checkbox-with-label>

        <checkbox-with-label
          class="mt-1"
          :label="'Special Occurrence you have access to has been added'"
          v-model="user.notificationNewSpecialOccurrence"
          @input="() => (isDirty = true)"
          :disabled="true"
          v-b-tooltip.left
          title="In development"
        ></checkbox-with-label>

        <checkbox-with-label
          class="mt-1"
          :label="'Special Occurrence you have access to has been completed'"
          v-model="user.notificationCompletedSpecialOccurrence"
          @input="() => (isDirty = true)"
          :disabled="true"
          v-b-tooltip.left
          title="In development"
        ></checkbox-with-label>
      </div>
    </div>

    <hr>
    <div class="d-flex justify-content-end">
      <button :disabled="!isDirty" class="btn btn-save btn-sm btn-success" @click="save()">
        <i class="far fa-save"></i>
        Save changes
      </button>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import CheckboxWithLabel from '../Misc/CheckboxWithLabel.vue';
  import { userClient } from '@/apiclient/opsboardapi';
  import { UserEditDto } from '@/apiclient/apiclient_generated';
  import { GlobalHelper } from '@/helpers/global-helper';

  @Component({
    components: {
      'checkbox-with-label': CheckboxWithLabel,
    },
  })
  export default class UserNotificationSettings extends Vue {
    private isDirty = false;
    private user: UserEditDto = new UserEditDto();

    async mounted() {
      this.user = await userClient.getNotificationSettings();
    }

    async save() {
      await userClient.updateNotificationSettings(this.user);
      GlobalHelper.NotifySuccess('Changes saved');
    }
  }
</script>

<style scoped lang="scss">
  .initial-settings {
  }
</style>
